/** Shared formatting utilities for dates and activity log entries. */

export function formatRelativeTime(dateStr: string | null): string {
  if (!dateStr) {
    return "Never";
  }
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60_000);
  if (diffMins < 1) {
    return "Just now";
  }
  if (diffMins < 60) {
    return `${diffMins}m ago`;
  }
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) {
    return `${diffHours}h ago`;
  }
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 30) {
    return `${diffDays}d ago`;
  }
  return date.toLocaleDateString();
}

export function formatDate(dateStr: string | null): string {
  if (!dateStr) {
    return "\u2014";
  }
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/** A calendar date (`2026-10-01`) as such, whatever the browser's time zone. */
export function formatUtcDate(dateStr: string): string {
  return new Date(`${dateStr}T00:00:00Z`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function formatDateTime(dateStr: string | null): string {
  if (!dateStr) {
    return "\u2014";
  }
  return new Date(dateStr).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatActionLabel(action: string): string {
  return action.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatDetail(detail: Record<string, unknown>): string | null {
  const keys = Object.keys(detail);
  if (keys.length === 0) {
    return null;
  }

  return keys
    .map((key) => {
      const label = key.replace(/_/g, " ");
      return `${label}: ${String(detail[key])}`;
    })
    .join(" \u00b7 ");
}
